<!-- Swiper конкретний чек -->
<template>
  <div class="product-wrapper">
    <div class="product_line">
      <div class="product-g">
        <transition name="fade-text" mode="out-in">
          <div class="product-l" :key="rozdilit ? 'split' : 'normal'">
            <p class="product-count">х{{ product.count }}</p>
            <p class="product-name">{{ product.nomenclatureName }}</p>
          </div>
        </transition>
        <div
          v-if="rozdilit && product.count > 1 && currentProduct.is"
          class="choiseCount"
        >
          <button
            class="btn_count btn_count_minus"
            :disabled="currentProduct.count == 1 || currentProduct.count == 0"
            @click="decreaseCount"
          >
            -
          </button>
          <div>{{ currentProduct.count }}</div>
          <button
            class="btn_count btn_count_plus"
            :disabled="
              currentProduct.count == product.count || currentProduct.count == 0
            "
            @click="increaseCount"
          >
            +
          </button>
        </div>
        <div v-else class="choiseCount-empty"></div>

        <div class="main_price" :class="{ main_price_one: !rozdilit }">
          <div class="product-r">{{ product.price }}₴</div>
          <label class="custom-checkbox" v-if="rozdilit">
            <input
              type="checkbox"
              @change="changeIsProduct"
              v-model="currentProduct.is"
            />
            <span class="checkmark"></span>
          </label>
        </div>
      </div>
    </div>

    <div v-for="modif in product.additionally" :key="modif.nomenclatureId">
      <div
        style="
          opacity: 0.5;
          display: flex;
          justify-content: flex-end;
          font-size: 12px;
          /* margin: 0 0 5px 10px; */
        "
      >
        + x{{ modif.count }} {{ modif.nomenclatureName }} {{ modif.price }}₴
      </div>
    </div>
    <div style="display: none">{{ render }}</div>
  </div>
</template>

<script>
export default {
  props: ["product", "currentProduct", "rozdilit"],
  data() {
    return {
      render: false,
    };
  },

  methods: {
    changeIsProduct() {
      this.render = !this.render;
    },
    decreaseCount() {
      if (this.currentProduct.count > 1) {
        this.currentProduct.count--;
        this.changeIsProduct();
      }
    },
    increaseCount() {
      if (this.currentProduct.count < this.product.count) {
        this.currentProduct.count++;
        this.changeIsProduct();
      }
    },
  },
};
</script>

<style scoped>
#app-slider {
  height: 100%;
}

.btn_count {
  border: none;
  background-color: transparent;
  margin: 0;
  padding: 0;
  cursor: pointer;
  color: grey;
}
.btn_count_minus {
  transform: translateY(0.5px);
}

.product-g {
  width: 100%;
  display: flex;
  justify-content: space-between;
  padding-bottom: 0;
  gap: 12px;
}

.product-r {
  display: flex;
  font-style: italic;
}

.product-count {
  /* color: #28a745; */
  color: var(--text-content) !important;

  padding-right: 5px;
}

.product-l {
  display: flex;
  flex: 1;
}

.product_line {
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
}

/*  */
.product-count-c {
  display: flex;
}
.product-count-c-empty {
  min-width: 61px;
}

/*  */

.choiseCount {
  display: flex;
  padding: 4px 9px;
  justify-content: center;
  background-color: #f8f8f8;
  align-items: center;
  gap: 14px;
  border-radius: 12.5px;
  height: 25px;
  /* border: 1px solid #e5e5e5; */
  color: grey;
  /* transform: translateY(-5px); */
  /* gap: 5px;
  padding: 1px 6px;
  border-radius: 5px;
  background: var(--content) !important; */
  width: 82px;
  min-width: 82px;
  max-width: 82px;
}
.choiseCount-empty {
  /* width: 82px;
  min-width: 82px; */
}

.custom-checkbox {
  display: inline-flex;
  align-items: center;
  cursor: pointer;
  position: relative;
  width: 24px;
  height: 24px;
}

.custom-checkbox input[type="checkbox"] {
  opacity: 0;
  width: 0;
  height: 0;
  position: absolute;
}

.custom-checkbox .checkmark {
  width: 100%;
  height: 100%;
  background-color: #eee;
  border-radius: 5px;
  transition: 0.2s ease-in-out;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
}

.custom-checkbox input:checked + .checkmark {
  background-color: #49b461;
  border-color: #49b461;
}

.custom-checkbox .checkmark::after {
  content: "";
  display: none;
  width: 6px;
  height: 12px;
  border: solid white;
  border-width: 0 2px 2px 0;
  transform: rotate(45deg) translateY(-1px);
  /* Зсув вгору на 1px */
}

.custom-checkbox input:checked + .checkmark::after {
  display: block;
}
.main_price {
  display: flex;
  gap: 5px;
  max-width: 70px;
  width: 70px;
  justify-content: space-between;
}
.main_price_one {
  justify-content: flex-end;
}
.product-wrapper {
  padding-bottom: 7px;
}

/* Анімації */
.fade-text-enter-active,
.fade-text-leave-active {
  transition: all 0.3s ease;
}
.fade-text-enter,
.fade-text-leave-to {
  opacity: 0;
  transform: translateY(-5px);
}

.fade-scale-enter-active,
.fade-scale-leave-active {
  transition: all 0.25s ease;
}
.fade-scale-enter,
.fade-scale-leave-to {
  opacity: 0;
  transform: scale(0.95);
}
</style>
